import {
  Component, Input, Output, EventEmitter, OnInit, ElementRef, HostListener,
  ViewEncapsulation, AfterContentInit
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AccordionModel } from './accordion.model';
import { EmitterService } from './emitter.service';
import { KEY_CONFIG } from './../../config/key-config';
import { UtilityService } from './../../providers/utility.service';


@Component({
  selector: 'app-accordion-list',
  templateUrl: './accordion-list.component.html',
  styleUrls: ['./accordion-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AccordionListComponent implements OnInit, AfterContentInit {

  tabIndex: number;
  disabled: boolean;

  @Input() option: AccordionModel;
  @Input() isSubAccordion: boolean;
  @Input() listLength: number;
  @Input() tabInside: boolean;

  @Output() selectedTab: EventEmitter<AccordionModel>;
  @Output() onLoadComplete: EventEmitter<boolean>;

  constructor(protected router: Router, private el: ElementRef, private emitter: EmitterService,
    private utilityService: UtilityService) {
    this.selectedTab = new EventEmitter<AccordionModel>();
    this.onLoadComplete = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.tabIndex = this.tabInside ? -1 : 0;
    this.disabled = this.listLength === 0 ? true : false;
      if (!this.option.ariaLabel) {
        this.option.ariaLabel = {
          'expand': 'Expand',
          'collapse': 'Collapse'
        };
      }

  }


  ngAfterContentInit() {
    this.onLoadComplete.next(true);
  }

  selectTab(tab, event) {
    this.emitter.next(tab);
    this.selectedTab.next(event);
  }

  handleSpanKeydown(event, tab): void {
    if (event.keyCode !== KEY_CONFIG.tabKey) {
      event.preventDefault();
      event.stopPropagation();
      if (event.keyCode === KEY_CONFIG.space || event.keyCode === KEY_CONFIG.enter) {
        this.selectTab(tab, event);
      }
    } else if (this.option.isActive && this.tabInside) {
      // change tab order
    }
  }
}

